<avd-code-example-header
    [packageName]="packageName"
    [getStartedLink]="getStartedLink"
    [storybookLink]="storybookLink"
    [repoLink]="repoLink"
></avd-code-example-header>

@for (example of examples; track example.variant) {
    <avd-code-example
        [label]="example.label"
        [description]="example.description"
        [htmlSnippet]="example.htmlSnippet"
    >
        <uilab-mat-stepper>
            <uilab-mat-step label="Step 1">
                <p>Provide account details.</p>
            </uilab-mat-step>
            <uilab-mat-step label="Step 2">
                <p>Confirm your preferences.</p>
            </uilab-mat-step>
            <uilab-mat-step label="Step 3">
                <p>Review and submit.</p>
            </uilab-mat-step>
        </uilab-mat-stepper>
    </avd-code-example>
}
